  /*============Brand Bar Controller
    ================================*/
  angular
    .module('vppApp')
    .controller('brandBarSSOController', brandBarSSOController);

  brandBarSSOController.$inject = ['$scope', '$state', 'brandBarSSOFactory', '$stateParams', 'vppConfig'];

  function brandBarSSOController($scope, $state, brandBarSSOFactory, $stateParams, vppConfig) {
		if (domainAbbr != 'ded' && domainAbbr != 'mpp'){
	    var stateName = $state.current.name;

	    brandBarSSOFactory().then(function(response) {
	      $scope.brandBar = response.data;
	      $scope.imgRight =  ($scope.brandBar.imgRight) ? $scope.brandBar.imgRight + '.png' : null;
	      $scope.imgLeft = ($scope.brandBar.imgLeft) ? $scope.brandBar.imgLeft + '.png' : null;
	      $scope.text = $scope.brandBar.text;
	      $scope.myClass = $scope.brandBar.text.myClass;
	    });
		}
  };
